__turbopack_context__.v({
  "loader": "styles-module-scss-module__jNVqAa__loader",
  "not_available_location_container": "styles-module-scss-module__jNVqAa__not_available_location_container",
  "pageContent": "styles-module-scss-module__jNVqAa__pageContent",
  "seo": "styles-module-scss-module__jNVqAa__seo",
});
